import { Store } from 'vuex'
import { Router } from 'vue-router'
import { State as StoreState } from '@/store/index'
import { useScreen } from '@/model/screen/screenTransition'
import { useStoreAction } from '@/model/store/store'

/**
 * 認証前の画面からTOP画面に遷移する
 * @param store vuex
 * @param router vue router
 */
const topRedirect = async (store: Store<StoreState>, router: Router) => {
  // 非ログイン処理設定
  await useStoreAction(store).init()
  // TOP画面に遷移
  useScreen().topRedirectNoauth(store, router)
}

/**
 * ユーザー名が設定している事をチェックして未設定の場合はTOP画面に遷移する
 * @param username ユーザー名
 * @param store vuex
 * @param router  vue router
 */
const checkFlowRedirect = async (username: string, store: Store<StoreState>, router: Router) => {
  // ユーザー名が未設定の場合はtop画面に遷移する
  if (!username) {
    topRedirect(store, router)
  }
}

export { topRedirect, checkFlowRedirect }
